import {OrderStatusService} from "./services/OrderStatusService";
import {OrderService} from "./services/OrderService";
import {OrderFormatService} from "./services/format/OrderFormatService";
import {OrderNotificationService} from "./services/OrderNotificationService";
import {orderUpdate, OrderUpdate} from "./directives/UpdateOrderDirective";

import Components from "./components";
import Filters from "./filters";
import Store from "./store";
import {ordersView, OrdersView} from "./view/OrdersViewComponent";
import {ordersDesktopView, OrdersDesktopView} from "./view/desktop/OrdersDesktopViewComponent";
import {ChildOrdersService} from "./services/child-orders/ChildOrdersService";

const ModuleName = "tfApp.orders";

export default angular.module(ModuleName, [Components(ModuleName), Filters, Store])
                      .component(OrdersView, ordersView())
                      .component(OrdersDesktopView, ordersDesktopView())
                      .service(OrderStatusService.id, OrderStatusService)
                      .service(OrderService.id, OrderService)
                      .service(OrderFormatService.id, OrderFormatService)
                      .service(OrderNotificationService.id, OrderNotificationService)
                      .service(ChildOrdersService.id, ChildOrdersService)
                      .directive(OrderUpdate, orderUpdate)
                      .name;
